<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 350px" class="yl-flex flex_between">
                    <Input placeholder="搜索名称" v-model="name" style="width: 250px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                </div>
                <Button class='ivu-btn-circle' type="primary" @click="addExpenditure">添加支出</Button>
            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>

                </RadioGroup>
            </div>

            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="status">
                        <div :style="{'color':row.status_color}" >{{row.status_name}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="pic">
                        <div style="color: #00A0FF" @click="checkPic" :data-pic="row.ext_info.pic">查看凭证</div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
            </div>
            <Modal v-model="modal" width="500" title="支出信息">
                <div class="multiple">
                    <div class="child-div inline-block">支出人</div>
                    <Input style="width: 200px" v-model="form.name"></Input>
                </div>
                <div class="multiple">
                    <div class="child-div inline-block">支出事项</div>
                    <Input style="width: 200px" v-model="form.matter"></Input>
                </div>
                <div class="multiple">
                    <div class="child-div inline-block">支出日期</div>
                    <DatePicker :value="form.expenditure_at" @on-change="(e) => {form.expenditure_at = e}" type="date"
                                placeholder="请选择时间"
                                style="width: 200px"></DatePicker>
                </div>
                <div class="multiple">
                    <div class="child-div inline-block">支出金额</div>
                    <Input style="width: 200px" v-model="form.money"><span slot="append">元</span></Input>
                </div>
                <div class="multiple">
                    <div class="child-div inline-block">备注</div>
                    <Input type="textarea" style="width: 300px" v-model="form.ext_info.remark"></Input>
                </div>
                <div class="multiple">
                    <div class="child-div inline-block">凭证</div>
                    <Button type="primary" v-if="form.ext_info.pic != ''" @click="checkPic" :data-pic="form.ext_info.pic">查看凭证</Button>
                    <Button type="primary" v-else @click="uploadModal = true">上传凭证</Button>
                </div>
                <div slot="footer">
                    <Button type="primary" @click="save()">确定</Button>
                </div>
            </Modal>
            <Modal
                    v-model="uploadModal"
                    title="上传图片"
                    @on-cancel="() => {uploadModal = false}"
                    @on-ok="fileOk">
                <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
            </Modal>
        </div>
    </Card>
</template>
<script>
    import {getOtherList,saveExpenditure} from "../../api/finance";
    import {mapGetters} from "vuex";
    import addFile from '../tool/addFile.vue';

    export default {
        name: "otherManagement",
        components: {addFile},

        data() {
            return {
                form: {
                    name: '',
                    matter: '',
                    expenditure_at: '',
                    money: '',
                    ext_info: {
                        remark: '',
                        pic: '',
                    }
                },
                uploadModal: false,
                modal: false,
                page: 1,
                count: 0,
                name: '',
                timePeriod: '0',
                timePeriodDate: [],
                datas: [
                ],
                columns: [
                    {
                        "title": "支出人",
                        "key": "name"
                    },
                    {
                        "title": "支出事项",
                        "key": "matter"
                    },
                    {
                        "title": "支出日期",
                        "key": "expenditure_at"
                    },
                    {
                        "title": "支出金额",
                        "key": "money"
                    },
                    {
                        "title": "审批状态",
                        "slot": "status"
                    },
                    {
                        "title": "备注",
                        "key": "remark"
                    },
                    {
                        "title": "凭证",
                        "slot": "pic"
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
            this.getList();
        },
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            fileOk() {
                var that = this;
                that.form.ext_info.pic = that.$refs['addFile'].fileUrl;
                that.$refs['addFile'].clear();
            },
            checkPic(e) {
                let pic = e.currentTarget.dataset.pic;
                window.open(pic)
            },
            save() {
                let that = this;
                that.throttle( async function () {
                    let data = {
                        token: that.token,
                        data: that.form,
                    };
                    let res = await saveExpenditure(that, data);
                    if (res.code == 1) {
                        that.modal = false;
                        that.initForm();
                        that.getList();
                    }
                }, 500)
            },
            initForm() {
                this.form = {
                    name: '',
                    matter: '',
                    expenditure_at: '',
                    money: '',
                    ext_info: {
                        remark: '',
                        pic: '',
                    }
                };
            },
            async loadData() {
            },
            changePage(e) {
                this.page = e;
                this.getList();
            },
            addExpenditure() {
                this.initForm();
                this.modal = true;
            },
            async getList() {
                let that = this;
                let data = {
                    page: that.page,
                    token: that.token,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                    name: that.name,
                };
                let res = await getOtherList(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                    that.count = res.data.count;
                }
            },
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .inline-block{
        display: inline-block;
    }
</style>
